import React from 'react';
import PropTypes from 'prop-types';

import './Footer.scss';

import commonConstant from '../../../common/_commonConstant';

const Footer = (props) => {
  const handleClassName = () => {
    if (props.match) {
      const { path } = props.match;

      switch (path) {
        case commonConstant.pathParkingStatus:
          return ' fix-bottom';
        default:
          return '';
      }
    }

    return '';
  };

  return <footer id="app-version" className={`Footer${handleClassName()}`}>Version: {process.env.REACT_APP_VERSION || 'dev'}</footer>;
};

Footer.propTypes = {
  'match': PropTypes.shape({
    'path': PropTypes.string.isRequired,
  }),
};

export default Footer;
